var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "identify-json-viewer" },
    [
      _vm.isCollapsible
        ? [
            _c(
              "div",
              { staticClass: "accordion", attrs: { id: `features-${_vm.id}` } },
              [
                _vm._l(_vm.features, function (feature, idx) {
                  return [
                    _c(
                      "div",
                      {
                        key: `feature-${idx}`,
                        staticClass: "card accordion",
                        attrs: { id: `feature-${idx}` },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "card-header",
                            attrs: { id: `headingFeature-${idx}` },
                          },
                          [
                            _c("div", { staticClass: "row no-gutters" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col d-flex align-items-center align-items-start p-0",
                                  attrs: {
                                    "data-toggle": "collapse",
                                    "data-target": `#collapse-${_vm.id}-${idx}`,
                                    "aria-controls": `collapse-${_vm.id}-${idx}`,
                                    "aria-expanded":
                                      _vm.expandId == _vm.featureId(feature),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getTitle(feature))),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col col-auto min-w-auto w-auto p-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-group w-100",
                                      attrs: {
                                        role: "group",
                                        "aria-label": "Feature Actions",
                                      },
                                    },
                                    _vm._l(
                                      _vm.globalActionsFeatureInfo(feature),
                                      function (action, aix) {
                                        return _c(
                                          "button",
                                          {
                                            key: `action-feature-${aix}`,
                                            staticClass:
                                              "btn btn-sm min-w-auto d-flex flex-row text-nowrap align-items-center",
                                            class: [
                                              !!action.label
                                                ? "btn-main"
                                                : "btn-link",
                                              action.class,
                                            ],
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.onGlobalAction(
                                                  action,
                                                  feature
                                                )
                                              },
                                            },
                                          },
                                          [
                                            action.icon
                                              ? _c("i", {
                                                  staticClass: "action",
                                                  class: action.icon,
                                                  attrs: {
                                                    "data-toggle":
                                                      "tooltip-city",
                                                    "data-placement": "left",
                                                    title: action.title,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            action.label
                                              ? _c("span", {
                                                  class: {
                                                    "pl-2": !!action.icon,
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$sanitize(
                                                        action.label
                                                      )
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "collapse",
                            class: {
                              show: _vm.expandId == _vm.featureId(feature),
                            },
                            attrs: {
                              id: `collapse-${_vm.id}-${idx}`,
                              "aria-labelledby": `headingFeature-${idx}`,
                              "data-parent": `#features-${_vm.id}`,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("RowViewer", {
                                  key: _vm.featureId(feature),
                                  attrs: {
                                    feature: feature,
                                    exclude: _vm.excludeProps,
                                    featureInfo: _vm.featureInfo,
                                    properties: { ...feature.properties },
                                  },
                                  on: {
                                    emitOpenPopup: _vm.onOpenPopup,
                                    dispatchEvent: _vm.onDispatchEvent,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._l(_vm.features, function (feature, idx) {
            return [
              _c("RowViewer", {
                key: _vm.featureId(feature),
                attrs: {
                  feature: feature,
                  title: _vm.getTitle(feature),
                  exclude: _vm.excludeProps,
                  featureInfo: _vm.featureInfo,
                  properties: { ...feature.properties },
                },
                on: {
                  emitOpenPopup: _vm.onOpenPopup,
                  dispatchEvent: _vm.onDispatchEvent,
                },
              }),
            ]
          }),
      _vm._v(" "),
      _vm.popup.component
        ? _c("info-modal", {
            ref: "infoModal",
            class: _vm.popupClassName,
            attrs: {
              propTitle: _vm.propTitle,
              component: _vm.popup.component,
              enablePrint: true,
            },
            on: { close: _vm.onClosePopup },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }